import { OptionsType, OptionTypeBase, StylesConfig } from 'react-select';

/** @todo: put a more specific return type */
export const buildStyleForSelectInput = (itemsCount: number): any => {
  const MIN_ITEMS_FOR_UPDATE_UI = 2;
  const customStyles: StylesConfig<OptionsType<OptionTypeBase>, true> = {
    control: (customStyles) => ({
      ...customStyles,
      boxShadow: '0 !important',
      borderColor: '#edf2f5',
      paddingTop: itemsCount >= MIN_ITEMS_FOR_UPDATE_UI ? 10 : undefined, // Fix UI padding error when too many items are selected
      '&:hover': {
        borderColor: '#edf2f5',
        backgroundColor: '#edf2f5',
      },
    }),
    multiValue: (customStyles) => ({
      ...customStyles,
      height: 'auto',
    }),
    valueContainer: (customStyles) => ({
      ...customStyles,
      flexWrap: 'wrap',
      maxHeight: '150px',
      overflowY: itemsCount >= MIN_ITEMS_FOR_UPDATE_UI ? 'auto' : undefined, // Fix UI scroll error when too many items are selected
    }),
    menuList: (customStyles) => ({
      ...customStyles,
      maxHeight: '150px',
      overflowY: 'scroll',
    }),
    placeholder: (customStyles) => ({
      ...customStyles,
      color: '#D8D8D8',
      fontWeight: 'bold',
      letterSpacing: '0.4px',
    }),
    indicatorSeparator: (customStyles) => ({
      ...customStyles,
      borderColor: '#edf2f5',
    }),
  };
  return customStyles;
};
